module.exports = __webpack_public_path__ + "media/images/posts/get_away_weddings-d4a19592523c0eab94e1d69d786361f2.jpg";